'use client';
import { styled } from '@mui/material/styles';

import RadioGroup from '@mui/material/RadioGroup';

export const BaseRadioGroup = styled(RadioGroup)();
